import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import PublicLayout from "@/components/layout/PublicLayout";
import api from "@/lib/api";
import { normalizeImageUrl } from "@/lib/imageUrl";
import { ProductCard } from "./ProductCard";

export default function MarketplaceCollection() {
  const { slug } = useParams();
  const [data, setData] = useState(undefined);
  useEffect(() => { api.get(`/marketplace/collection/${slug}`).then(({ data }) => setData(data)).catch(() => setData(null)); }, [slug]);

  if (data === undefined) return <PublicLayout><div className="max-w-7xl mx-auto px-4 py-16 text-slate-400">Loading…</div></PublicLayout>;
  if (data === null) return <PublicLayout><div className="max-w-7xl mx-auto px-4 py-16 text-center"><p className="font-display text-2xl uppercase">Collection not found</p><Link to="/marketplace" className="text-[#E63946] text-sm">Back to Marketplace</Link></div></PublicLayout>;

  const c = data.collection;
  return (
    <PublicLayout>
      <div data-testid="marketplace-collection">
        <section className="relative bg-[#0A192F] text-white">
          {c.hero_image_url && <img src={normalizeImageUrl(c.hero_image_url)} alt={c.name} className="absolute inset-0 w-full h-full object-cover opacity-40" />}
          <div className="relative max-w-7xl mx-auto px-4 py-14">
            <Link to="/marketplace" className="text-xs uppercase tracking-wider text-white/60">Marketplace</Link>
            <h1 className="font-display text-4xl uppercase tracking-tight mt-1">{c.name}</h1>
            {c.description && <p className="text-white/70 mt-2 max-w-xl">{c.description}</p>}
          </div>
        </section>
        <div className="max-w-7xl mx-auto px-4 py-8">
          {data.products.length === 0 ? <div className="text-slate-400 py-16 text-center">No products in this collection yet.</div>
            : <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">{data.products.map((p) => <ProductCard key={p.id} p={p} />)}</div>}
        </div>
      </div>
    </PublicLayout>
  );
}
